import React, { useState } from "react";
import { Modal, DatePicker, Select, Button } from "antd";

const { Option } = Select;

export default function LedgerSelectedModal({
  isLedgerSelectedModalVisible,
  toggleLedgerSelectedModal,
  fetchLedgerData,
  ledgerFetching,
}) {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const onFromDateChange = (date) => {
    setFromDate(date);
    if (toDate && date && date.isAfter(toDate)) {
      setToDate(null); // Reset toDate if it is earlier than fromDate
    }
  };

  const onToDateChange = (date) => {
    setToDate(date);
  };

  const onSelectChange = (value) => {
    setSelectedOption(value);
  };

  const toggleLedgerModal = () => {
    setFromDate(null);
    setToDate(null);
    setSelectedOption(null);
    toggleLedgerSelectedModal();
  };

  return (
    <Modal
      title="Ledger Selected"
      visible={isLedgerSelectedModalVisible}
      onCancel={toggleLedgerModal}
      footer={null}
    >
      <div
        className="ledger-modal-container"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          maxWidth: "400px",
          margin: "0 auto",
        }}
      >
        <Select
          placeholder="Select Type"
          onChange={onSelectChange}
          value={selectedOption}
        >
          <Option value="Regular">Regular</Option>
          <Option value="Equipment">Equipment</Option>
        </Select>

        <div style={{ display: "flex", gap: "10px" }}>
          <DatePicker
            placeholder="From Date"
            value={fromDate}
            onChange={onFromDateChange}
            disabledDate={(current) =>
              toDate && current && current.isAfter(toDate)
            }
            style={{ width: "50%" }}
          />
          <DatePicker
            placeholder="To Date"
            value={toDate}
            onChange={onToDateChange}
            disabledDate={(current) =>
              fromDate && current && current.isBefore(fromDate)
            }
            style={{ width: "50%" }}
          />
        </div>

        <div
          className="button-container"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button type="default" onClick={toggleLedgerModal}>
            Cancel
          </Button>
          <Button
            style={{ margin: "0 10px" }}
            type="primary"
            disabled={!selectedOption || !fromDate || !toDate}
            onClick={() =>
              fetchLedgerData(
                selectedOption,
                fromDate?.format("DD.MM.YYYY"),
                toDate?.format("DD.MM.YYYY")
              )
            }
            loading={ledgerFetching}
          >
            Apply
          </Button>
        </div>
      </div>
    </Modal>
  );
}
